<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-row>
        <b-col class="m-2" no-gutters>
          <b-button @click="deleteLine" class="ml-1" variant="info">Delete Line</b-button>
          <b-button @click="newSale" class="ml-1" variant="info">New Sale</b-button>
          <b-button @click="parkSale" class="ml-1" variant="info">Park Sale</b-button>
          <b-button @click="retrieveParkedSale" class="ml-1" variant="info">Retrieve Sale</b-button>
          <b-button @click="searchSatsangi" class="ml-1" variant="info">Search Satsangi</b-button>
          <b-button @click="editLineItem" class="ml-1" variant="info">Edit Line</b-button>
          <b-button @click="submitCash" class="ml-1" variant="info">Payments</b-button>
          <b-button @click="printReceipt" class="ml-1" variant="info">Print Receipt</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import Vue from "vue";

export default {
  name: "SaleOptionButtons",
  props:{
    showPrintButton: {
      type: Boolean,
      default: false,
    }
  },
  components: {},

  methods: {
    editLineItem() {
      this.$emit("editLineItem");
    },
    deleteLine() {
      this.$emit("deleteLine");
    },
    newSale() {
      this.$emit("newSale");
    },
    parkSale() {
      this.$emit("parkSale");
    },
    retrieveParkedSale() {
      this.$emit("retrieveParkedSale");
    },
    searchSatsangi() {
      this.$emit("searchSatsangi");
    },
    submitCash(){
      this.$emit("payments");
    },
    printReceipt(){
      this.$emit("printReceipt");
    },
  },
  updated: function() {
    this.$nextTick(function() {
      this.$emit("updated");
    });
  }
};
</script>
